import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export enum TASK_STATUS_OPTIONS {
  RUNNING = 1,
  // eslint-disable-next-line no-magic-numbers
  TIMEOUT = 2,
  // eslint-disable-next-line no-magic-numbers
  SUCCESS = 3,
  // eslint-disable-next-line no-magic-numbers
  FAIL = 4
}

export interface TaskStatus {
  ctime: string
  mtime: string
  msg: string
  task_status: number
}
@Injectable()
export class VersionUpdateService {
  constructor (private http: Http) {
  }

  upgradeUpload (data: any, uploadProgressFunction: (progress: any) => void) {
    return this.http.postForm('/upgrade/upload', data, uploadProgressFunction)
  }

  getUpgradeStatus () {
    return this.http.post<TaskStatus>('/upgrade/task/status', {})
  }
}
